import { Client } from './client.model';
import { Product } from './product.model';
import { User } from './user.model';

export interface Item {

    discount?: any;
    groupId?: any;
    free: any;
    contents: any;
  closingdate: any;
    documents: any[];
    returnProductConditions: any;
    invoiceNumber: null;
  startServiceTime: string;
  itemService: any;
  activeInvocing: boolean;
  tags: any;
  confirmedBy:any;
  id:number; //itemId
  checkInId:number,
  createdBy: string;
  creationDate: any;
  confirmedDate:any;
  currency: string;
  customerCity: string;
  customerCountry: any;
  detail: string;
  detailRef: string;
  endService: any;
  itemId: number;
  orderId:number,
  orderNumber:string,
  lastModifiedBy: string;
  lastModifiedDate: any;
  name: string;
  number: string;
  pos: any;
  prices: Price[];
  product: string;
  productType: ProductType;
  productUrl: string;
  qte: number;
  ref: any;
  serviceCountries: any[];
  serviceDuration: number;
  source: any;
  startService: any;
  staticProduc: any;
  status: string;
  supplier: Client;
  beneficiaries: Client[];
  customer:Client;
  customerName:string;
  roomPrice:number,
  totalPrice:number,
  noAdults:number,
  noChilds:number,
  noBabies:number,
  checkin:string,
  roomName:string,
  notes:any,
  repeater?: boolean,
}

export interface ProductType {
  productTypeId: any;
  name: string;
  nameEn: string;
  service: boolean;
  hasChildrenPolicies: boolean;
  isTravel: boolean;
  priceTypeAvailable: string;
  SellingModelAvailable: string;
  priceForGroup: boolean;
  purchaseRate: boolean;
  useGroupedAccount: boolean;
  city: string;
  code:string;
  vat: any;
}
export interface Payment {
  parentCustomer: any;
  mainBeneficiary: any;
  ref: number;
  paymentId: number;
  amount: number;
  bank: string;
  createdBy: string;
  creationDate: any;
  currency: string;
  customer: Client;
  document: any;
  lastModifiedBy: string;
  lastModifiedDate: any;
  number: string;
  paymentMethod: any;
  status: string;
}

export interface Price {
  createdBy: string;
  creationDate: any;
  currency: string;
  lastModifiedBy: string;
  lastModifiedDate: any;
  priceId: number;
  scope: string;
  value: number;
}

export interface Order {
  expiredAt: string;
  groupId: any;
  remarks: string;
  closed: any;
  ref: string;
  events: any;
  selectedClient: any;
  orderId: number;
  createdBy: string;
  creationDate: any;
  currency: string;
  customer: Client;
  user: User;
  invoiceDate?: any;
  discount:any;
  items: Item[];
  lastModifiedBy: string;
  lastModifiedDate: any;
  number: string;
  orderType: string;
  payments: Payment[];
  prices: Price[];
  status: string;
  tax: any[];
  pos:any;
  name2:any;
}

export class OrderCtor implements Order {
  orderId: number;
  createdBy: string;
  creationDate: any;
  currency: string;
  user: User;
  customer: Client;
  invoiceDate?: any;

  
  items: Item[] = [];
  lastModifiedBy: string;
  lastModifiedDate: any;
  number: string;
  orderType: string;
  payments: Payment[] = [];
  prices: Price[] = [];
  status: string;
  tax: any[] = [];

  public constructor(fields?: {
    orderId?: number;
    createdBy?: string;
    creationDate?: any;
    currency?: string;
    customer?: Client;
    invoiceDate?: any;
    items?: Item[];
    lastModifiedBy?: string;
    lastModifiedDate?: any;
    number?: string;
    orderType?: string;
    payments?: Payment[];
    prices?: Price[];
    status?: string;
    tax?: any[];
  }) {
    if (fields) Object.assign(this, fields);
  }
  expiredAt: string;
  groupId: any;
  remarks: string;
  closed: any;
  name2: any;
  discount: any;
  ref: string;
  events: any;
  pos: any;
  selectedClient: any;
}
